import type { TRule } from 'fela';

export const pagination: TRule = () => ({
    marginTop: '2rem',

    '& .ant-pagination-item, .ant-pagination-jump-next, .ant-pagination-jump-prev': {
        display: 'none',
    },
});
